import { MapManager } from './classes/MapManager';
import { PageFinder } from './classes/PageFinder';
import { Dropdown } from './classes/Dropdown';
import { Search } from './classes/Search';
(new MapManager()).init();
(new PageFinder()).init();
(new Dropdown()).init();
(new Search()).init();
